import { render, staticRenderFns } from "./EditSurveyWarning.vue?vue&type=template&id=0069a0f8&scoped=true"
import script from "./EditSurveyWarning.vue?vue&type=script&lang=js"
export * from "./EditSurveyWarning.vue?vue&type=script&lang=js"
import style0 from "./EditSurveyWarning.vue?vue&type=style&index=0&id=0069a0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069a0f8",
  null
  
)

export default component.exports